import { blue } from "@ant-design/colors"
import { Radio, RadioProps } from "antd"

type Props = RadioProps & {
  onBorderClick: () => void
}

const RadioButton = (props: Props) => {
  const style = props.disabled
    ? disabledStyle
    : props.checked
      ? checkedStyle
      : uncheckedStyle
  const { onBorderClick, ...radioProps } = props

  const handleDivClick = () => {
    if (!props.disabled){
      props.onBorderClick()
    }
  }
  
  return <div style={style} onClick={handleDivClick}>
    <Radio {...radioProps}>
      <div style={{paddingLeft: '4px'}}>
        {props.children}
      </div>
    </Radio>
  </div>
}

const uncheckedStyle = {
  borderColor: '#00000026',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: '12px',
  padding: '8px',
  cursor: 'pointer',
  backgroundColor: 'transparent'
}

const checkedStyle = {
  ...uncheckedStyle,
  borderColor: blue.primary,
  backgroundColor: blue[0]
}

const disabledStyle = {
  ...uncheckedStyle,
  borderColor: '#0000000F',
  backgroundColor: '#0000000A',
  cursor: 'not-allowed'
}

export default RadioButton